// extracted by mini-css-extract-plugin
export default {"inputContainer":"mimic___styles_inputContainer__lvwHN","root":"mimic___styles_root__IQdyv"};